import { render, staticRenderFns } from "./TwitterNewsProduct.vue?vue&type=template&id=4ef4d945&scoped=true"
import script from "./TwitterNewsProduct.vue?vue&type=script&lang=ts"
export * from "./TwitterNewsProduct.vue?vue&type=script&lang=ts"
import style0 from "./TwitterNewsProduct.vue?vue&type=style&index=0&id=4ef4d945&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef4d945",
  null
  
)

export default component.exports